import styled from 'styled-components';

export const ContainerLoadInit = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  gap: 12px;
  margin-bottom: 24px;
`;

export const SubContainerCenter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 992px) {
    width: 744px;
    margin: 0 auto;
  }
`;

export const ContainerFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 12px;
`;

export const TitleFooter = styled.h1`
  font-size: 14px;
  font-weight: 700;
  color: #161d1f;
  line-height: 20px;
  margin: 34px 0 8px 0;
`;

export const TextLI = styled.li`
  font-size: 14px;
  font-weight: 400;
  color: #161d1f;
  line-height: 20px;
  white-space: pre-wrap;
  list-style-position: inside;
  padding-left: 20px;
  text-indent: -20px;
`;
